import { CustomAttributesSection } from "components/CustomAttributesSection/CustomAttributesSection";
import { SimulationPersonProperties } from "../types";
import { isAnyValueProvided } from "../utils";
import { AddressDetails } from "./AddressDetails";
import { Agreements } from "./Agreements";
import { PersonDetails } from "./PersonDetails";
import { PointsBalance } from "./PointsBalance";
import { TransactionalHistory } from "./TransactionalHistory";

interface Props {
  fieldNamePrefix: "customer" | "referrer";
  setFieldValue: (field: string, value: any) => void;
  data?: SimulationPersonProperties;
  setValues: (
    fields: React.SetStateAction<{
      customer?: SimulationPersonProperties;
      referrer?: SimulationPersonProperties;
    }>,
  ) => void;
}

export const PersonDetailsSection = ({
  fieldNamePrefix,
  setFieldValue,
  data,
  setValues,
}: Props) => {
  const isTransactionAttached = isAnyValueProvided([
    data?.firstTransactionDate,
    data?.lastTransactionDate,
    data?.numberOfPurchases,
    data?.purchaseAmount,
    data?.averagePurchaseAmount,
  ]);

  const isPointsBalanceAttached = isAnyValueProvided([
    data?.activePoints,
    data?.spentPoints,
    data?.earnedPoints,
    data?.lockedPoints,
    data?.blockedPoints,
    data?.expiredPoints,
  ]);

  return (
    <>
      <PersonDetails
        fieldNamePrefix={fieldNamePrefix}
        setCustomerValues={(memberDetails) =>
          setValues({
            [fieldNamePrefix]: {
              ...data,
              ...memberDetails,
            },
          })
        }
        arePreloadedData={!!data?.id}
      />
      <AddressDetails
        fieldNamePrefix={fieldNamePrefix}
        setFieldValue={setFieldValue}
        isAddressAttached={!!data?.address}
      />
      <TransactionalHistory
        fieldNamePrefix={fieldNamePrefix}
        clearTransactionFields={() =>
          setValues({
            [fieldNamePrefix]: {
              ...data,
              firstTransactionDate: undefined,
              lastTransactionDate: undefined,
              numberOfPurchases: undefined,
              averagePurchaseAmount: undefined,
              purchaseAmount: undefined,
            },
          })
        }
        isTransactionAttached={!!isTransactionAttached}
      />
      <PointsBalance
        fieldNamePrefix={fieldNamePrefix}
        isPointsBalanceAttached={!!isPointsBalanceAttached}
        clearPointsBalanceFields={() =>
          setValues({
            [fieldNamePrefix]: {
              ...data,
              activePoints: undefined,
              usedPoints: undefined,
              earnedPoints: undefined,
              lockedPoints: undefined,
              blockedPoints: undefined,
              expiredPoints: undefined,
            },
          })
        }
      />
      <CustomAttributesSection
        labels={data?.labels || []}
        name={fieldNamePrefix}
      />
      <Agreements fieldNamePrefix={fieldNamePrefix} />
    </>
  );
};
